import React, { useCallback, useMemo, FC } from 'react';
import { Game } from '@/entities/game/ui/Game';
import { useGameAccessCheck } from '@/shared/hooks';
import { WishlistToggle } from '@/features/wishlist/ui/wishlist-toggle';
import { Box } from '@/shared/ui/box';

export interface GameType {
  id: number;
  title: string;
  pageTitle: string;
  type: string;
  filters: string[];
  providerId: string;
  providerName: string;
  imageUrl: string;
  videoUrl?: string;
  minBet: number;
}

interface ConditionalWrapperGameProps {
  handleClickGame: (game: GameType) => void;
  game: GameType;
  hasScroll: boolean;
}

export const ConditionalWrapperGame: FC<ConditionalWrapperGameProps> = ({
  handleClickGame,
  game,
  hasScroll,
}) => {
  const accessHelpers = useGameAccessCheck();
  const canOpenGame = accessHelpers.canOpenGame(game);

  const handleView = useCallback(
    (e) => {
      if (canOpenGame) {
        if (e.target.closest('a')) {
          return;
        }

        handleClickGame(game);
      }
    },
    [canOpenGame, handleClickGame, game]
  );

  const wishlistToggle = useMemo(
    () => <WishlistToggle gameId={game.id} title={game.title} />,
    [game.id, game.title]
  );

  return (
    <Box
      onClick={handleView}
      className={`game-card-${game?.title}`}
      role="button"
    >
      <Game
        hasScroll={hasScroll}
        wishlistToggleSlot={wishlistToggle}
        imageUrl={game.imageUrl}
        game={game}
      />
    </Box>
  );
};
